import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { Carousel } from 'dibs-carousel';
import { StarRating } from 'dibs-elements/exports/StarRating';
import { Link } from 'dibs-elements/src/Link';

import { SharedCarouselDot } from '../../shared/SharedCarouselDot/SharedCarouselDot';

import styles from './PdpSharedTestimonial.scss';

type Props = {
    trackCtaClick: () => void;
};

const testimonials = [
    {
        title: (
            <FormattedMessage
                id="PdpSharedTestimonial.review.customer1.title"
                defaultMessage="Jenna Lyons, Fashion Designer"
            />
        ),
        message: (
            <FormattedMessage
                id="PdpSharedTestimonial.review.customer1.message"
                defaultMessage="“When I first discovered 1stDibs, I had no idea that ten years later I would’ve turned around and realized that 80% of my apartment had been sourced from one place.”"
            />
        ),
    },
    {
        title: (
            <FormattedMessage
                id="PdpSharedTestimonial.review.customer2.title"
                defaultMessage="Pamela, Customer"
            />
        ),
        message: (
            <FormattedMessage
                id="PdpSharedTestimonial.review.customer2.message"
                defaultMessage="“The seller worked with me on the price and shipped my bag immediately. It's perfect and I absolutely love it! I highly recommend 1stDibs.”"
            />
        ),
        rating: 5,
    },
    {
        title: (
            <FormattedMessage
                id="PdpSharedTestimonial.review.customer3.title"
                defaultMessage="Drew, Customer"
            />
        ),
        message: (
            <FormattedMessage
                id="PdpSharedTestimonial.review.customer3.message"
                defaultMessage="“I was very happy with my experience. When I did have questions relevant to 1stDibs, their customer service was exceptionally helpful. I wouldn't hesitate to shop here again.”"
            />
        ),
        rating: 5,
    },
];

export const PdpSharedTestimonial: FC<Props> = ({ trackCtaClick }) => {
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <FormattedMessage
                    id="PdpSharedTestimonial.header"
                    defaultMessage="What Design Lovers <italic>Are Saying About 1stDibs</italic>"
                    values={{
                        italic: message => <div className={styles.italic}>{message}</div>,
                    }}
                />
            </div>
            <Carousel
                isAutoRun
                dataTn="testimonial-carousel"
                classNames={{
                    wrapper: styles.carouselWrapper,
                    list: styles.carouselList,
                    dotsWrapper: styles.carouselDots,
                }}
                hideArrows
                totalItems={3}
                autoRunDuration={8000}
                itemsPerPage={1}
                step={1}
                renderItem={({ index }: { index: number }) => {
                    const { rating, title, message } = testimonials[index];
                    return (
                        <>
                            <div className={styles.title}>
                                {title}
                                <span className={styles.rating}>
                                    {rating && (
                                        <StarRating
                                            rating={rating}
                                            size="xxx-small"
                                            starTheme="dark"
                                        />
                                    )}
                                </span>
                            </div>
                            <div>{message}</div>
                        </>
                    );
                }}
                showDots
                renderDot={({ isCurrentDot }: { isCurrentDot?: boolean } = {}) => (
                    <SharedCarouselDot isActive={!!isCurrentDot} dark size="small" />
                )}
            />
            <Link
                dataTn="testimonial-cta"
                href="/collections/most-saved-items/"
                className={styles.link}
                onClick={trackCtaClick}
            >
                <FormattedMessage
                    id="PdpSharedTestimonial.cta"
                    defaultMessage="Shop the Most-Saved Collection"
                />
            </Link>
        </div>
    );
};
